import React, { useEffect, useRef } from 'react';

import { Alert, type AlertProps } from '@meu-mapa-nev/design-system';

/**
 * `Alert` que recebe foco quando aparece ou quando o conteúdo muda.
 *
 * `role="alert"`/`role="status"` sozinho não garante o anúncio: leitores de
 * tela só observam uma região `live` que já existia na página antes da
 * atualização, e um aviso de erro nasce depois, inserido no DOM. É o mesmo
 * problema que `ResumoDeErros.tsx` resolve com foco explícito — aqui é a
 * versão para um aviso de texto único, não uma lista de campos.
 */
export const AlertComFoco: React.FC<AlertProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, [props.type, props.title, props.children]);

  return (
    <div ref={ref} tabIndex={-1}>
      <Alert {...props} />
    </div>
  );
};
